<template>
  <div class="account-row location">
    <div class="heading">
      <h2>{{$ml.get(`Location`)}}</h2>
      <app-btn 
      :loading="loading"
        @click="save"
      >
        {{ $ml.get(`save`) }}
      </app-btn>
    </div>
    <form>
      <!-- <pre>{{data.country}}</pre> -->
      <app-sel
        v-model="data.country"
        filterable
        :label="$ml.get(`Country`)"
        :items="countries"
        :keyName="'value'"
        is-object
        @input="save"
        class="text-input user-sel"
      >
        <template v-slot="{ items }">
          <app-sel-opt v-for="item in items" :value="item" :key="item.key">
            {{ $ml.get(item.label) }}
          </app-sel-opt>
        </template>
      </app-sel>

      <app-text-input
        :label="data.state.label"
        :type="data.state.type"
        v-model="data.state.value"
      />
      <app-text-input
        :label="data.city.label"
        :type="data.city.type"
        v-model="data.city.value"
      />
      <app-text-input
        :label="data.address.label"
        :type="data.address.type"
        v-model="data.address.value"
      />
      <app-text-input
        :label="data.zipCode.label"
        :type="data.zipCode.type"
        v-model="data.zipCode.value"
      />
    </form>

  </div>
</template>

<script>
import API from '@/api'

export default {
  props : {
    data : {
      required : true
    }
  },
  data() {
    return {
      country: {

      },
      loading: false
    }
  },
  // mounted() {
  //   this.country = this.countries.find(x => x.value == this.userCountry);
  // },
  methods : {
    save() {
      this.loading = true;
      if(!this.data.zipCode.value || !this.data.address.value || !this.data.state.value || !this.data.city.value) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get('Please, enter full location data'),
          type: 'error'
        }) 

        this.loading = false
      } else {
        let request = {
          country : this.data.country.value,
          // country : this.country.value,
          city : this.data.city.value,
          address : this.data.address.value,
          state : this.data.state.value,
          zip : this.data.zipCode.value
        };
        return API.user.updateLocation(request).then(res => {
          if(res.data.success) {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(`Your data was successfully updated!`),
              type : 'success',
            });
          }
          this.$store.dispatch('user/updateData');
        }).catch(err => {
          this.$notify({
            group: 'notices',
            title: this.$ml.get(`Error! "${err.response.data.err}"`),
            type : 'error',
          });
        }).finally(() => {
          this.loading = false
        });
      }

      
    }
  },
  computed: {
    countries() {
      return this.$store.getters['countries/data'];
    },
    // userCountry() {
    //   return this.$store.getters['user/data'].country;
    // }
  },
}
</script>

<style lang="scss" scoped>
  .location {
    .user-sel {
      margin-bottom: 24px;
    }
  }
</style>
